import { RegisterUserT, OPTin } from '@/store/auth/types';
import axios from './index';

type UserAPI = {
  _id: string;
  email: string;
  firstName: string;
  lastName: string;
  taxInfo: {
    taxId: string;
    country: string;
  };
};

interface UserEnrichedAPI extends UserAPI {
  gender: string;
  phoneNumber: string;
  pointsEarned: number;
  localisation: Localisation;
  accounts: Account[];
  address: Address;
}
type Account = {
  id: string;
  role: string;
};
type Address = {
  city: string;
  country: string;
  countryCode: string;
  houseNumber: string;
  street: string;
  street2: string;
  zip: string;
};
type Localisation = {
  country: string;
  currency: string;
  language: string;
};

export type PreferencesAPI = {
  preferredThing: string;
  thingAvatars: ThingAvatars[];
};
export type ThingAvatars = {
  thingId: string;
  avatarColor?: number;
  avatarImageName?: string;
  nickName?: string;
  package?: string;
  carOdometerM: number;
  isArchived: boolean;
  ymme?: {
    licensePlate: string | null;
    VIN: string | null;
  };
};
export interface UserFeature {
  status: string;
  feature: string;
}
type optinResponseDTO = {
  accountId: string;
  action: string;
  name: string;
  timestamp: string;
  userId: string;
};
// Docs: https://tt4.thinxcloud-dev.de/doc/#api-Users
export async function getUserIdAPI(): Promise<UserAPI[]> {
  const { data } = await axios.get(`/users`);
  return data;
}
export async function getUser(userId: string): Promise<UserEnrichedAPI> {
  const { data } = await axios.get(`/users/${userId}`);
  return data;
}
export async function getUserPreferences(): Promise<PreferencesAPI> {
  const { data } = await axios.get(`/v4/users/preferences`);
  return data;
}
export async function exportEvents(thingId: string): Promise<void> {
  await axios.get(`/events/request-data-dump?thingId=${thingId}`);
}

export async function getFeaturesAPI(accountId: string): Promise<UserFeature[]> {
  const response = await axios.get(`/accounts/${accountId}/features`);
  return response.data;
}
export async function getUserPreferencesWithArchivedAPI() {
  const { data } = await axios.get(`/v4/users/preferences?includeArchived=true`);
  return data.thingAvatars;
}
export async function loginAPI(email: string, password: string) {
  const { data } = await axios.post('/auth/login/local', { email, password });
  return data;
}
export async function registerAPI(data: RegisterUserT) {
  if (!data.referrer) {
    data.referrer = 'ryd-pay-automotive';
  }

  await axios.post('/auth/register', { ...data, referralPlatform: 'Android_Automotive' });
}
export async function changePwAPI(newPassword: string) {
  await axios.post('/auth/change-password', { newPassword });
}
export async function resendPwdAPI(email: string) {
  await axios.post('/auth/resend-password', { email });
}

export async function setPreferredVehicleAPI(preferredThing: string) {
  await axios.patch(`/v4/users/preferences`, { preferredThing });

}
export async function QRVerifyAPI(qrToken: string) {
  await axios.post('/qr/verify', { qrToken });
}
export const setOptinAPI = async (optinData: OPTin) => {
  return axios.post('/optins', optinData);
};
export const getOptinAPI = async (name: string): Promise<optinResponseDTO> => {
  const response = await axios({
    method: 'get',
    url: `optins/name/${name}`
  });
  console.log(response.data);

  return response.data;
};